/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetFuelXOnchainTransactionResponse
 */
export interface GetFuelXOnchainTransactionResponse {
    /**
     * 
     * @type {string}
     * @memberof GetFuelXOnchainTransactionResponse
     */
    fuelXRecipient: string;
}

/**
 * Check if a given object implements the GetFuelXOnchainTransactionResponse interface.
 */
export function instanceOfGetFuelXOnchainTransactionResponse(value: object): value is GetFuelXOnchainTransactionResponse {
    if (!('fuelXRecipient' in value) || value['fuelXRecipient'] === undefined) return false;
    return true;
}

export function GetFuelXOnchainTransactionResponseFromJSON(json: any): GetFuelXOnchainTransactionResponse {
    return GetFuelXOnchainTransactionResponseFromJSONTyped(json, false);
}

export function GetFuelXOnchainTransactionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetFuelXOnchainTransactionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'fuelXRecipient': json['fuelXRecipient'],
    };
}

export function GetFuelXOnchainTransactionResponseToJSON(json: any): GetFuelXOnchainTransactionResponse {
    return GetFuelXOnchainTransactionResponseToJSONTyped(json, false);
}

export function GetFuelXOnchainTransactionResponseToJSONTyped(value?: GetFuelXOnchainTransactionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fuelXRecipient': value['fuelXRecipient'],
    };
}

